export * from './header/header.component';
export * from './footer/footer.component';
export * from './search-input/search-input.component';
export * from './switcher/switcher.component';
